'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (layout, dashboard) {
    return layout.hideLegend ? {
        enabled: false
    } : _extends({}, getLegend(dashboard), getItemStyle(dashboard));
};

var DEFAULT_ITEM_STYLE = {
    fontSize: '13px',
    fontWeight: 'normal'
};

var DASHBOARD_ITEM_STYLE = {
    fontSize: '11px',
    fontWeight: 500
};

var DEFAULT_LEGEND = {
    symbolWidth: 11,
    symbolHeight: 11,
    itemMarginBottom: 2
};

var DASHBOARD_LEGEND = {
    symbolPadding: 3,
    itemDistance: 10
};

function getItemStyle(dashboard) {
    return {
        itemStyle: _extends({}, DEFAULT_ITEM_STYLE, dashboard ? DASHBOARD_ITEM_STYLE : null)
    };
}

function getLegend(dashboard) {
    return _extends({}, DEFAULT_LEGEND, dashboard ? DASHBOARD_LEGEND : null);
}
//# sourceMappingURL=legend.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/legend.js
 ** module id = 241
 ** module chunks = 0 1
 **/